import {Component} from "@angular/core";

@Component({
    selector: 'app-no-association-component',
    templateUrl: './_noassociation.html',
  styleUrl: './contract.scss',
})

export class NoAssociationComponent{}
